export const INITIATE_FEEDBACK_LOAD = 'supplier-feedback/INITIATE_FEEDBACK_LOAD'
export const AFTER_FEEDBACK_LOAD = 'supplier-feedback/AFTER_FEEDBACK_LOAD'
export const RESET_FEEDBACK_LIST = 'supplier-feedback/RESET_FEEDBACK_LIST'
export const ADD_FEEDBACK_LIST = 'supplier-feedback/ADD_FEEDBACK_LIST'
export const REMOVE_SINGLE_FEEDBACK = 'supplier-feedback/REMOVE_SINGLE_FEEDBACK'
export const SET_ERROR_LIST = 'supplier-feedback/SET_ERROR_LIST'
